
import React from 'react'
import Box from './Box'

/**
 * Text component.
 */

export default function Text({ size = 1, children, ...props }) {
  return <Box is="span" fontSize={size} {...props}>
    {children}
  </Box>
}